import type { IVideoSrcParserOptions } from "../types";

export const parseOpts = (
  opts: IVideoSrcParserOptions,
  isForPrintPdf = false,
): IVideoSrcParserOptions => ({
  ...opts,
  controls: isForPrintPdf ? false : opts.controls,
  autoplay: isForPrintPdf ? false : opts.autoplay,
});
